import React from 'react';
import './InfoPage.css';

function Safety() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Informações de Segurança</h1>

        <section className="info-section">
          <h2>Sua segurança é nossa prioridade</h2>
          <p>Na Nukki, estamos comprometidos em criar uma comunidade segura e protegida para hóspedes e anfitriões.</p>
        </section>

        <section className="info-section">
          <h3>Confiança e Verificação</h3>
          <div className="safety-feature">
            <h4>Verificação de Identidade</h4>
            <p>Verificamos a identidade de nossos usuários através de documentos oficiais, confirmação de e-mail e verificação de telefone para ajudar a construir confiança em nossa comunidade.</p>
          </div>
          <div className="safety-feature">
            <h4>Pagamentos Seguros</h4>
            <p>Todos os pagamentos são processados através de nossa plataforma segura. Nunca transfira dinheiro ou se comunique fora da plataforma Nukki.</p>
          </div>
          <div className="safety-feature">
            <h4>Avaliações e Classificações</h4>
            <p>Tanto hóspedes quanto anfitriões podem deixar avaliações honestas após cada estadia, ajudando a construir uma comunidade transparente.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Diretrizes de Segurança para Hóspedes</h3>
          <ul>
            <li>Leia avaliações de hóspedes anteriores antes de reservar</li>
            <li>Verifique os detalhes da propriedade e comodidades</li>
            <li>Comunique-se apenas através da plataforma Nukki</li>
            <li>Verifique detectores de fumaça e saídas de emergência ao chegar</li>
            <li>Relate qualquer preocupação de segurança imediatamente</li>
            <li>Mantenha a propriedade segura durante sua estadia</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Diretrizes de Segurança para Anfitriões</h3>
          <ul>
            <li>Instale detectores de fumaça e alarmes de monóxido de carbono</li>
            <li>Forneça um extintor de incêndio e kit de primeiros socorros</li>
            <li>Compartilhe informações de contato de emergência</li>
            <li>Garanta que todos os aparelhos sejam seguros e funcionais</li>
            <li>Mantenha saídas de emergência livres</li>
            <li>Avalie hóspedes através de nosso sistema de verificação</li>
            <li>Relate atividades suspeitas</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Suporte de Emergência</h3>
          <p>Se você está em perigo imediato, entre em contato com os serviços de emergência locais imediatamente.</p>
          <p>Para preocupações urgentes de segurança relacionadas à sua estadia na Nukki, nossa equipe de suporte 24/7 está aqui para ajudar.</p>
          <div className="emergency-contact">
            <strong>Linha de Suporte de Emergência:</strong> Disponível através dos detalhes da sua reserva
          </div>
        </section>

        <section className="info-section">
          <h3>Reportar Problemas de Segurança</h3>
          <p>Se você vivenciar ou testemunhar alguma preocupação de segurança, por favor reporte imediatamente. Levamos todos os relatórios a sério e investigamos minuciosamente.</p>
        </section>
      </div>
    </div>
  );
}

export default Safety;
